import React from 'react';

import './Header.scss';
import HeaderNavbar from "./HeaderNavbar";

/**
 * @typedef {Object} HeaderDescriptor
 *
 * @property {string} path - The absolute path of the header image
 * @property {string} height - The height to constrain the image to
 * @property {number} width - The width to constrain the image to
 * @property {string} title - The main title to be displayed in the header
 * @property {string} subtitle - The Page subtitle
 *
 * <pre>
 * {
 *     path: '/style/images/seven360/ncc/Passport_Website_Logo.png',
 *     height: '80px',
 *     width: '160px',
 *     title: 'School Readiness Passport',
 *     subtitle: 'Northumberland Early Years Inclusion Management System',
 * }
 * </pre>
 *
 */

/**
 * Common component for rendering the entire header with logos and styling across the Passport
 * family of applications
 *
 * @typedef {object} HeaderProps
 * @property {HeaderDescriptor} headerLogoDetails The descriptor for displaying this header
 *
 * @component
 * @param {HeaderProps} props
 * @returns {JSX.Element}
 *
 * @example
 *   <Header headerLogoDetails={headerLogoNorthumberland} menuDescriptor={passportNorthumberlandMenu}/>
 */

const Header = ({headerLogoDetails, menuDescriptor}) =>
{
    return (
        <div className='estar-header-container'>
            <HeaderNavbar menuDescriptor={menuDescriptor}/>
            <div className="estar-page-header">
                <div className='left-image' style={{backgroundImage: 'url(' + headerLogoDetails.path + ')', width: headerLogoDetails.width, height: headerLogoDetails.height, marginTop: headerLogoDetails.marginTop}}></div>
                <div className="left-align-header">
                    <p className="font-sml-uppercase">{headerLogoDetails.subtitle}</p>
                    <p className="font-lg-bold">{headerLogoDetails.title}</p>
                </div>
                <div className='right-image'></div>
            </div>
        </div>
    )
}

export default Header;